const dict: { [K: string]: string } = {
    'Bad Request': 'Peticion inválida',
    'dueDate': 'Fecha vencimiento',
    'must be a future date': 'Debe ser en el futuro'
};

function translate(message: string): string {
    if (dict[message]) {
        return dict[message];
    }
    return message;
}

/**
 *  {
 *      "timestamp": 1530292190820,
 *      "status": 400,
 *      "error": "Bad Request",
 *      "errors": [
 *      {
 *          "codes": [
 *              "Future.addDTO.dueDate",
 *              "Future.dueDate",
 *              "Future.java.util.Date",
 *              "Future"
 *          ],
 *          "arguments": [
 *              {
 *                  "codes": [
 *                      "addDTO.dueDate",
 *                      "dueDate"
 *                  ],
 *                  "arguments": null,
 *                  "defaultMessage": "dueDate",
 *                  "code": "dueDate"
 *              }
 *          ],
 *          "defaultMessage": "must be a future date",
 *          "objectName": "addDTO",
 *          "field": "dueDate",
 *          "rejectedValue": 1530291540000,
 *          "bindingFailure": false,
 *          "code": "Future"
 *      }
 *  ],
 *      "message": "Validation failed for object='addDTO'. Error count: 1",
 *      "path": "/api/admin/addOpportunity"
 *  }
 */

interface ExtractedError {
    type: string;
    code: number;
    properties: ExtractedErrorDetail[]
}

interface ExtractedErrorDetail {
    property: string;
    message: string;
}

export const extractError = (err: any): ExtractedError => {
    if (!err.response) {
        return {
            type: 'No conocido',
            code: 500,
            properties: []
        }
    }

    return {
        type: translate(err.response.error),
        code: err.response.status,
        properties: (err.response.errors || []).map((data: any) => {
            return {
                property: translate(data.field),
                message: translate(data.defaultMessage),
            }
        })
    }

};



// WEBPACK FOOTER //
// ./src/utils/errorHelper.ts